// removed by extract-text-webpack-plugin
module.exports = {"root":"ConfirmSignUp__root___excCd","phone":"ConfirmSignUp__phone___gHSDn","message":"ConfirmSignUp__message___3nilR","appScrean":"ConfirmSignUp__appScrean___2XL0m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmSignUp/ConfirmSignUp.scss
// module id = 2218
// module chunks = 0